export { default as GovernanceV2Mspa } from "./GovernanceV2Mspa";